<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="editForm" :rules="rules" ref="editForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="活动名称：" prop="activityName">
            <el-input style="width: 424px;" v-model="editForm.activityName" placeholder="请输入活动名称"></el-input>
          </el-form-item>
          <el-form-item label="限领类型：" prop="limitType">
            <el-radio-group v-model="editForm.limitType">
                <el-radio :label="1">每天限领</el-radio>
                <el-radio :label="2">总限领</el-radio>
              </el-radio-group>
          </el-form-item>
          <el-form-item label="限领次数：" prop="limitNum">
            <el-input style="width: 424px;" v-model="editForm.limitNum" placeholder="请输入限领次数"></el-input>
          </el-form-item>
          <el-form-item label="活动规则：" prop="activityRule">
            <el-input style="width: 424px;" type="textarea" rows="5" v-model="editForm.activityRule" placeholder="请输入活动规则"></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input style="width: 424px;" type="textarea" rows="5" v-model="editForm.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item label="背景图：" prop="backgroundImageUrl">
            <el-upload
              :action="baseUrl+'/system/common/upload/uploadFile'"
              list-type="picture-card"
              :headers="{'Authorization': token}"
              :multiple="false"
              :limit="1"
              :file-list="backgroundImageUrlList"
              :on-remove="delImgBtn.bind(null,{'type':1})"
              :on-success="uploadImgBtn.bind(null,{'type':1})">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">建议尺寸：96*96px，最多一张，若需要更换图片，请先删除原图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="中奖显示图：" prop="giftImgUrl">
            <el-upload
              :action="baseUrl+'/system/common/upload/uploadFile'"
              list-type="picture-card"
              :headers="{'Authorization': token}"
              :limit="1"
              :file-list="giftImgUrlList"
              :on-remove="delImgBtn.bind(null,{'type':2})"
              :on-success="uploadImgBtn.bind(null,{'type':2})">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">建议尺寸：96*96px，最多一张，若需要更换图片，请先删除原图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="未获奖显示图：" prop="notGiftImgUrl">
            <el-upload
              :action="baseUrl+'/system/common/upload/uploadFile'"
              list-type="picture-card"
              :headers="{'Authorization': token}"
              :multiple="false"
              :limit="1"
              :file-list="notGiftImgUrlList"
              :on-remove="delImgBtn.bind(null,{'type':3})"
              :on-success="uploadImgBtn.bind(null,{'type':3})">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">建议尺寸：96*96px，最多一张，若需要更换图片，请先删除原图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="editForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveLotteryActivityConfig, fetchLotteryActivityConfigDetailById, updateLotteryActivityConfig } from '@/api/prizeDraw'
export default {
  name: 'PrizeDrawAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fullscreenLoading: false,
      dataId: this.$route.query.dataId,
      backgroundImageUrlList: [],
      giftImgUrlList: [],
      notGiftImgUrlList: [],
      editForm: {
        activityName:'',
        limitType:1,
        limitNum:'',
        activityRule:'',
        remark:'',
        backgroundImageUrl: '',
        giftImgUrl:'',
        notGiftImgUrl:'',
        status: false
      },
      rules: {
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        limitType: [
          { required: true, message: '请选择限领类型', trigger: 'blur' }
        ],
        limitNum: [
          { required: true, message: '请输入限领次数', trigger: 'blur' }
        ],
        backgroundImageUrl: [
          { required: true, message: '请上传背景图', trigger: 'blur' }
        ],
        giftImgUrl: [
          { required: true, message: '请上传中奖显示图', trigger: 'blur' }
        ],
        notGiftImgUrl: [
          { required: true, message: '请上传未获奖显示图', trigger: 'blur' }
        ]
      },
      isOne:1
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    if(this.dataId != ''){
      // 编辑信息
      this.detailInfoFun();
    }
  },
  methods: {
    /* 商品详情数据 */
    detailInfoFun(){
      var that = this;
      fetchLotteryActivityConfigDetailById({id:that.dataId}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          data.status =  data.status == 1 ? true : false;
          // 背景图
          that.backgroundImageUrlList.push({url: data.backgroundImageUrl});
          // 获奖礼品图
          that.giftImgUrlList.push({url: data.giftImgUrl});
          // 未获奖礼品图
          that.notGiftImgUrlList.push({url: data.notGiftImgUrl});
          that.editForm = data;
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg);
        }
      });
    },
    // 商品主图上传
    uploadImgBtn (obj, file) {
      var type = obj.type;
      var that = this;
      switch (type) {
        case 1:
          // 背景图
          that.editForm.backgroundImageUrl = file.data.fileUrl
          break;
        case 2:
          // 获奖礼品图
          that.editForm.giftImgUrl = file.data.fileUrl
          break;
        case 3:
          // 未获奖礼品图
          that.editForm.notGiftImgUrl = file.data.fileUrl
          break;
      }
    },
    /* 删除上传的图片 */
    delImgBtn(obj,file,fileList){
      var type = obj.type;
      var that = this;
      switch (type) {
        case 1:
          // 背景图
          var thumb = '';
          fileList.forEach(function(item){
            thumb = item.url;
          });
          that.editForm.backgroundImageUrl = thumb;
          break;
        case 2:
          // 获奖礼品图
          var thumb = '';
          fileList.forEach(function(item){
            thumb = item.url;
          });
          that.editForm.giftImgUrl = thumb;
          break;
        case 3:
          // 未获奖礼品图
          var thumb = '';
          fileList.forEach(function(item){
            thumb = item.url;
          });
          that.editForm.notGiftImgUrl = thumb;
          break;
      }
    },
    // 保存操作
    saveBtn(){
      var that = this;
      var dataId = that.dataId;
      var editForm = that.editForm;
      let status = editForm.status ? 1 : 0
      let passData = {
        activityName: editForm.activityName,
        limitType:editForm.limitType,
        limitNum:editForm.limitNum,
        activityRule:editForm.activityRule,
        remark:editForm.remark,
        backgroundImageUrl:editForm.backgroundImageUrl,
        giftImgUrl:editForm.giftImgUrl,
        notGiftImgUrl:editForm.notGiftImgUrl,
        status:status
      }
      if(dataId != ''){
        passData.id = dataId;
        updateLotteryActivityConfig(passData).then((res) => {
          that.backDataFun(res);
        })
      }else{
        saveLotteryActivityConfig(passData).then((res) => {
          that.backDataFun(res);
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/prizeDraw/PrizeDrawAdd.vue